import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import React, { useState } from "react";
import { IndicadorFlat } from "../../../components/Indicador";
import { SwitchBlueGreen } from "../../../components/Switch";
import { Venda, VendaMedidas } from "../../../models/venda";
import {
  ListItemCombustivel,
  ListItemCombustivelLayout,
} from "../../caixa/ListItemCombustivel";
import { DashPanel } from "../DashPanel";
import { KPIComparativo } from "../KPIComparativo";

export interface PanelCombustiveisProps {
  vendaCombustiveis: Venda[];
  vendaComparativo: Venda[];
  totaisCombustiveis: VendaMedidas;
  totaisComparativo: VendaMedidas;
}

export const PanelCombustiveis = (props: PanelCombustiveisProps) => {
  const [checkedPorQtd, setCheckedPorQtd] = useState(true);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedPorQtd(event.target.checked);
  };

  return (
    <DashPanel
      title="Combustíveis"
      headerAction={
        <div>
          <Grid component="label" container alignItems="center" spacing={1}>
            <Grid item>R$</Grid>
            <Grid item>
              <SwitchBlueGreen
                checked={checkedPorQtd}
                onChange={handleSwitchChange}
                name="switchListaCombustiveis"
              />
            </Grid>
            <Grid item>(L)</Grid>
          </Grid>
        </div>
      }
    >
      <Grid
        container
        justifyContent="space-between"
        style={{
          paddingLeft: "8px",
          paddingRight: "8px",
          paddingBottom: "8px",
        }}
      >
        <Grid item>
          <IndicadorFlat
            titulo="# Vendas"
            valor={props.totaisCombustiveis.contagem}
          />
          <KPIComparativo
            valorBase={props.totaisCombustiveis.contagem}
            valor={props.totaisComparativo.contagem}
            format="0"
          />
        </Grid>
        <Grid item style={{ textAlign: "right" }}>
          <IndicadorFlat
            titulo="Quantidade"
            lt
            valor={props.totaisCombustiveis.quantidade}
            showDecimals={false}
          />
          <KPIComparativo
            valorBase={props.totaisCombustiveis.quantidade}
            valor={props.totaisComparativo.quantidade}
            format=",0"
          />
        </Grid>
        <Grid item style={{ textAlign: "right" }}>
          <IndicadorFlat
            titulo="Faturamento"
            r$
            valor={props.totaisCombustiveis.totalLiquido}
            showDecimals={false}
          >
            <KPIComparativo
              valorBase={props.totaisCombustiveis.totalLiquido}
              valor={props.totaisComparativo.totalLiquido}
              format=",0"
            />
          </IndicadorFlat>
        </Grid>
      </Grid>

      <List>
        {props.vendaCombustiveis.map((x) => (
          <ListItemCombustivel
            key={x.codigo}
            vendaCombustivel={x}
            comparativo={props.vendaComparativo.find(
              (c) => c.codigo === x.codigo,
            )}
            layout={
              checkedPorQtd
                ? ListItemCombustivelLayout.PorQuantidade
                : ListItemCombustivelLayout.PorValor
            }
          />
        ))}
      </List>
    </DashPanel>
  );
};
